import { ConversationalOnboarding } from '~/components/onboarding/ConversationalOnboarding';

export default function OnboardingChatRoute() {
  return <ConversationalOnboarding />;
}
